import { type ComponentPropsWithoutRef, memo } from 'react';
import { LoadingSpinner } from '@/shared/components/LoadingSpinner';
import { cn } from '@/utils/tailwind.util';
const Container = memo((props: ComponentPropsWithoutRef<'div'>) => {
  const {
    className,
    onClick,
    children,
    ...rest
  } = props;
  return <div {...rest} onClick={e => {
    onClick?.(e);
    e.stopPropagation();
  }} className={cn('relative rounded-xs border border-opacity group/image-thumbnail w-fit overflow-hidden flex items-center h-full', className)}>
      <div className="absolute inset-0 cursor-pointer bg-dimmed opacity-0 transition-opacity group-hover/image-thumbnail:opacity-100" />
      {children}
    </div>;
});
const Thumbnail = memo((props: ComponentPropsWithoutRef<'img'>) => {
  const {
    className,
    src,
    ...rest
  } = props;
  return <img {...rest} className={cn('w-full h-full object-cover max-h-[132px] max-w-[558px]', className)} src={src} />;
});
const RemoveButton = ({
  className,
  onClick,
  children
}: {
  className?: string;
  onClick: () => void;
  children: React.ReactNode;
}) => {
  return <div onMouseDown={e => {
    e.stopPropagation();
    e.preventDefault();
  }} onClick={e => {
    e.stopPropagation();
    e.preventDefault();
    onClick();
  }} className={cn('flex items-center justify-center absolute right-[-6px] top-[-6px] border-2 border-white rounded-full z-10 bg-gray-500 p-3xs cursor-pointer', className)} data-sentry-component="RemoveButton" data-sentry-source-file="QuizImage.tsx">
      {children}
    </div>;
};
const Loading = ({
  className
}: {
  className?: string;
}) => {
  return <div className={cn('flex h-full w-full max-w-[287px] items-center justify-center rounded-xs border border-opacity-assistive bg-dimmed', className)} data-sentry-component="Loading" data-sentry-source-file="QuizImage.tsx">
      <LoadingSpinner className="size-lg text-white" data-sentry-element="LoadingSpinner" data-sentry-source-file="QuizImage.tsx" />
    </div>;
};
export const QuizImage = {
  Container,
  Thumbnail,
  RemoveButton,
  Loading
};